import { render, staticRenderFns } from "./JwJiaocaiList.vue?vue&type=template&id=52d71e20"
import script from "./JwJiaocaiList.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports